<template>
  <layout-basic>
    <v-container>
      <section class="banner-text relative">
        <v-row class="text-center mt-5" align="center" justify="center">
          <v-col cols="12" md="12">
            <h1 class="banner-title font-sora mb-3 mt-5">Course Categories</h1>
            <h3>
              Develop your staff, induct new starters and manage areas of
              compliance.
            </h3>
          </v-col>
          <v-col cols="12" md="12">
            <v-row align="center" justify="center">
              <v-col
                v-for="option in CourseOptions"
                :key="option.id"
                :id="option.id"
                cols="12"
                sm="6"
                md="4"
              >
                <div :class="[type == option.id && 'active', 'filter-card', option.static && 'filter-card-static']" @click="!option.static && selectCategory(option)">
                  <h2 :class="option.id">{{ option.title }}</h2>
                  <p class="subtitle">{{ option.subtitle }}</p>
                  <p class="description">{{ option.description }}</p>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>
    </v-container>
    <div class="absolute">
      <img class="course-background-img" :src="['static/pages/course-library/' + type + '.png']" />
    </div>
    <v-container class="course-wrapper">
      <section id="improve-section" class="container-new improve-section">
        <div class="improve-section">
          <v-row no-gutters>
            <v-col cols="12" md="12" class="text-center">
              <!-- Ensure title and subtitle are accessible from allCourses -->
              <h1
                :class="[type, 'banner-title font-sora mb-3']"
                v-if="allCourses[type]"
              >
                {{ allCourses[type].title }}
              </h1>
              <h3 v-if="allCourses[type]" class="mb-5">
                {{ allCourses[type].subtitle }}
              </h3>
            </v-col>

            <!-- Render courses dynamically -->
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="6"
                v-for="course in courses"
                :key="course.id"
              >
              <a :href="`/course/${course.id}`">
                  <div class="course-card">
                    <div class="course-card-content">
                      <div class="course-title">
                        <h2 :class="type">{{ course.title }}</h2>
                        <span :class="[type, 'course-duration']">{{
                          course.duration
                        }}</span>
                      </div>
                      <p class="course-description">
                        {{ course.description }}
                      </p>
                    </div>
                  </div>
                </a>
              </v-col>
            </v-row>
          </v-row>
        </div>
        <v-row v-if="moreCourses">
          <v-col cols="12" md="12">
            <div class="text-center show_more_courses">
              <v-btn class="green-button" @click="getMoreCourses"
                >Show More Courses</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </section>
      <!-- <v-row>
                <v-col cols="12" md="12">
                    <div class="text-center mb-50">
                        <v-btn href="/pricing" color="secondary" class="try_free fs-22">Pricing</v-btn>
                    </div>
                </v-col>
            </v-row> -->
    </v-container>
    <hr class="pb-2" style="margin-top: 1px;" />
  </layout-basic>
</template>

<style>
.v-menu__content {
  max-height: unset !important;
}
.v-select__selection--comma {
  overflow: unset !important;
}
</style>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import CourseList from '@/../public/static/courselist.json';
import NewCourseList from '@/../public/static/newcourselist.json';
export default {
  name: 'CourseLibrary',
  metaInfo() {
      return {
          title: "Explore IMPROVE's Course Library: 100+ Customisable Microlearning Courses",
          meta: [
              // Meta Description
              { name: 'description', content: "Discover IMPROVE's extensive course library featuring 100+ editable microlearning courses. Tailor content to meet your team's learning and development needs." },
              
              // Keywords
              { name: 'keywords', content: "IMPROVE course library, microlearning courses, customisable courses, off-the-shelf courses, online training, SME learning solutions, employee development" },
              
              // Open Graph / Facebook Tags
              { property: 'og:title', content: "Explore IMPROVE's Course Library: 100+ Customisable Microlearning Courses" },
              { property: 'og:description', content: "Discover IMPROVE's extensive course library featuring 100+ editable microlearning courses. Tailor content to meet your team's learning and development needs." },
              { property: 'og:image', content: "https://www.improve.online/static/seo.png" },
              { property: 'og:type', content: 'website' },
              { property: 'og:url', content: 'https://www.improve.online/courses' },
              
              // Twitter Card Tags
              { name: 'twitter:card', content: 'summary_large_image' },
              { name: 'twitter:title', content: "Explore IMPROVE's Course Library: 100+ Customisable Microlearning Courses" },
              { name: 'twitter:description', content: "Discover IMPROVE's extensive course library featuring 100+ editable microlearning courses. Tailor content to meet your team's learning and development needs." },
              { name: 'twitter:image', content: "https://www.improve.online/static/seo.png" }
          ],
          link: [
              // Canonical URL
              { rel: 'canonical', href: 'https://www.improve.online/courses' }
          ]
      };
  },
  components: {
    LayoutBasic,
  },
  data() {
    return {
      CourseList,
      NewCourseList,
      courses: [],
      type: 'Compliance',
      allCourses: {},
      id: this.$route.query.course,
      count: 0,
      moreCourses: true,
      CourseOptions: [
        {
          id: 'Compliance',
          title: 'Compliance',
          subtitle: 'Workplace compliance courses.',
          description:
            'Workplace compliance ensures adherence to regulations and standards for your organisation.',
        },
        {
          id: 'ComplianceManagementGuideCourses',
          title: 'Compliance / Management',
          subtitle: 'Safeguard your organisation.',
          description:
            'Courses to help you protect your organisation from malicious intent, both intentional and unintentional.',
        },
        {
          id: 'HealthAndSafetyCourses',
          title: 'Health & Safety',
          subtitle: 'Ensuring employee wellbeing.',
          description:
            'Prioritising health and safety is crucial for both employee well-being and the success of your organisation.',
        },
        {
          id: 'ITSkillsCourses',
          title: 'IT Skills',
          subtitle: 'Upskill your IT skills.',
          description:
            'Beginner, intermediate, and advanced courses on how to use Word, Excel, PowerPoint, and Outlook.',
        },
        {
          id: 'PeopleAndRelationships',
          title: 'People & Relationships',
          subtitle: 'Creating strong workplace relationships.',
          description:
            'Courses on team working, wellbeing, customer service and how to improve workplace relationships.',
        },
        {
          id: 'SalesCourses',
          title: 'Sales',
          subtitle: "Increase your sales team's capabilities.",
          description:
            'Improve how your business promotes and sells products or services to customers or clients.',
        },
        {
          id: 'WorkingFromHomeCourses',
          title: 'Working from Home',
          subtitle: 'Tool kits for remote working.',
          description:
            'A range of comprehensive courses for individuals seeking to work more effectively at home.',
        },
        {
          id: 'ProjectManagementCourses',
          title: 'Project Management',
          subtitle: 'Effective project management.',
          description:
            'Courses to ensure organised workflow and successful outcomes in the workplace.',
        },
        {
          id: 'ManagementAndLeadershipCourses',
          title: 'Management & Leadership',
          subtitle: 'ILM-aligned leadership development.',
          description:
            'Develop core Leadership and Management Skills for Aspiring, First Line and Mid-Senior Level Managers and Directors in line with ILM standards. 55 interactive modules available to purchase optionally from as little as £1,995 for your entire business. Talk to us today.',
          static: true,
        },
      ],
    };
  },
  mounted() {
    this.addMetaDetail();
    this.allCourses = this.NewCourseList;

    // Prefilter based on the "course" query parameter
    const courseType = this.$route.query.course || this.type; // Default to this.type if no query param
    if (courseType) {
      this.type = courseType;
      this.getCourses();
    }
  },
  watch: {
    // Watch for changes in the query parameter
    '$route.query.course'(newCourse, oldCourse) {
      if (newCourse && newCourse !== oldCourse) {
        this.type = newCourse; // Update the selected type
        this.courses = []; // Clear current courses
        this.getCourses(); // Fetch the updated courses
      }
    },
  },
  methods: {
    getMoreCourses() {
      this.moreCourses = true;
      this.courses = [];
      let i = 0;

      if (this.type !== 'all') {
        // Loop through the courses in the selected type
        for (let key in this.allCourses[this.type]) {
          // Skip the "title" and "subtitle" keys
          if (key === 'title' || key === 'subtitle') {
            continue; // Ignore title and subtitle
          }

          // Only add courses (exclude title and subtitle)
          if (i < this.count + 9) {
            this.courses.push(this.allCourses[this.type][key]);
            i++;
          } else {
            break;
          }
        }

        this.count += 9;

        // Check if we've reached the end of the list for the selected category
        if (
          this.count >=
          Object.keys(this.allCourses[this.type]).filter(
            (key) => key !== 'title' && key !== 'subtitle'
          ).length
        ) {
          this.moreCourses = false;
        }
      } else {
        // If "all" is selected, iterate through all categories and filter out title and subtitle
        for (let category in this.allCourses) {
          for (let key in this.allCourses[category]) {
            if (key === 'title' || key === 'subtitle') {
              continue; // Skip title and subtitle
            }

            if (i < this.count + 9) {
              this.courses.push(this.allCourses[category][key]);
              i++;
            } else {
              break;
            }
          }
        }

        this.count += 9;

        // You can set an appropriate limit or condition here for "all"
        if (this.count >= 50) {
          this.moreCourses = false;
        }
      }
    },
    getCourses() {
      this.count = 0;
      this.getMoreCourses();
    },
    selectCategory(option) {
      this.type = option.id;
      this.courses = [];
      this.getCourses();

      // Update the URL query parameter without reloading
      this.$router.push({
        query: { course: this.type },
      });

      this.scrollToSection();
    },
    scrollToSection() {
      const section = document.getElementById('improve-section');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    addMetaDetail() {
      document.title =
        'IMPROVE: 100+ Editable, Off-the-Shelf, Microlearning Courses';
      document.getElementsByTagName('meta')['description'].content =
        "Make the most of IMPROVE's comprehensive course library, contains 100+ microlearning courses that you can customise to suit your people's learning needs.";
    },
  },
};
</script>

<style scoped>
.filter-card {
  background-color: white;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: left;
  margin: 10px; /* Optional, for spacing between multiple boxes */
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
}

.filter-card:hover {
  transform: scale(1.05); /* Slightly increase the size */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Increase shadow */
}

.filter-card-static {
  cursor: default;
}

.filter-card-static:hover {
  transform: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.filter-card h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}

.filter-card p.subtitle {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.filter-card p.description {
  color: #555;
  padding: 0 55px 0 0 !important;
  background-color: transparent !important;
}

.course-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
  min-height: 100%; /* Ensure the card takes full height */
}

.course-card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1; /* Ensures content stretches to fill card height */
}

.course-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
}

.course-title h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  margin-right: 100px;
  margin-top: 10px;
}

.course-duration {
  position: absolute;
  top: -5px;
  right: -20px;
  background-color: #7bc7a4;
  color: white;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 5px 20px;
  font-size: 14px;
  font-weight: bold;
}

.course-description {
  color: #333;
  font-size: 16px;
  margin: 10px 0 0 0;
  line-height: 1.5;
  flex-grow: 1; /* Ensure the description grows to fill available space */
}

/* Ensure all course cards are the same height without modifying the v-col and v-row */
.v-col .course-card {
  height: 100%; /* This makes the card fill the column */
}

.Compliance {
  color: #7bc7a4;
}

.course-card .Compliance.course-duration {
  background-color: #7bc7a4;
  color: white !important;
}

#Compliance .filter-card.active {
  background-color: #7bc7a4;
  color: white;
}

.ComplianceManagementGuideCourses {
  color: #123f3d;
}

.course-card .ComplianceManagementGuideCourses.course-duration {
  background-color: #123f3d;
  color: white;
}

#ComplianceManagementGuideCourses .filter-card.active {
  background-color: #123f3d;
  color: white;
}

.HealthAndSafetyCourses {
  color: #f3ba34;
}

.course-card .HealthAndSafetyCourses.course-duration {
  background-color: #f3ba34;
  color: white !important;
}

#HealthAndSafetyCourses .filter-card.active {
  background-color: #f3ba34;
  color: white;
}

.ITSkillsCourses {
  color: #76bbd6;
}

.course-card .ITSkillsCourses.course-duration {
  background-color: #76bbd6;
  color: white !important;
}

#ITSkillsCourses .filter-card.active {
  background-color: #76bbd6;
  color: white;
}

.ManagementAndLeadershipCourses {
  color: #eb572a;
}

.course-card .ManagementAndLeadershipCourses.course-duration {
  background-color: #eb572a;
  color: white !important;
}

#ManagementAndLeadershipCourses .filter-card.active {
  background-color: #eb572a;
  color: white;
}

.PeopleAndRelationships {
  color: #baadd1;
}

.course-card .PeopleAndRelationships.course-duration {
  background-color: #baadd1;
  color: white !important;
}

#PeopleAndRelationships .filter-card.active {
  background-color: #baadd1;
  color: white;
}

.SalesCourses {
  color: #f27182;
}

.course-card .SalesCourses.course-duration {
  background-color: #f27182;
  color: white !important;
}

#SalesCourses .filter-card.active {
  background-color: #f27182;
  color: white;
}

.WorkingFromHomeCourses {
  color: #d83e3d;
}

.course-card .WorkingFromHomeCourses.course-duration {
  background-color: #d83e3d;
  color: white !important;
}

#WorkingFromHomeCourses .filter-card.active {
  background-color: #d83e3d;
  color: white;
}

.ProjectManagementCourses {
  color: #a0c13c;
}

.course-card .ProjectManagementCourses.course-duration {
  background-color: #a0c13c;
  color: white !important;
}

#ProjectManagementCourses .filter-card.active {
  background-color: #a0c13c;
  color: white;
}

#Compliance .filter-card.active .Compliance,
#Compliance .filter-card.active p,
#ComplianceManagementGuideCourses .filter-card.active .ComplianceManagementGuideCourses,
#ComplianceManagementGuideCourses .filter-card.active p,
#HealthAndSafetyCourses .filter-card.active .HealthAndSafetyCourses,
#HealthAndSafetyCourses .filter-card.active p,
#ITSkillsCourses .filter-card.active .ITSkillsCourses,
#ITSkillsCourses .filter-card.active p,
#ManagementAndLeadershipCourses .filter-card.active .ManagementAndLeadershipCourses,
#ManagementAndLeadershipCourses .filter-card.active p,
#PeopleAndRelationships .filter-card.active .PeopleAndRelationships,
#PeopleAndRelationships .filter-card.active p,
#SalesCourses .filter-card.active .SalesCourses,
#SalesCourses .filter-card.active p,
#WorkingFromHomeCourses .filter-card.active .WorkingFromHomeCourses,
#WorkingFromHomeCourses .filter-card.active p,
#ProjectManagementCourses .filter-card.active .ProjectManagementCourses,
#ProjectManagementCourses .filter-card.active p {
  color: #fff !important;
}

.course-background-img{
  width: calc(100% + 12px);
  margin-left: -12px;
  position: relative;
  z-index: 0;
  padding-top: 175px;
}

.course-wrapper {
  position: relative;  
  z-index: 1;
}

@media (max-width: 768px) {
  .course-background-img {
    padding-top: 300px;
  }
}
</style>

